export const TEXT_COLOR_OPTIONS = [
  "#272727",
  "#535353",
  "#8C5327",
  "#BB8F68",
  "#00583D",
  "#3E7C69",
  "#08B07D",
  "#48B7B1",
  "#4AB3E0",
  "#4A8FC6",
  "#545EA6",
  "#555088",
  "#8351A6",
  "#A74DA4",
  "#B14A81",
  "#DC4A7B",
  "#DC7CA5",
  "#D20707",
  "#EA564C",
  "#E27E31",
  "#EFA449",
  "#EEB753",
  "#EAE355",
  "#D9DF4B",
];
